import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import AnalyticsManager from '../../../app/analytics';
import './favorite-btn.scss';
import on from 'assets/icons/full-heart.svg';
import off from 'assets/icons/empty-heart.svg';

/* actions */
import * as Actions from 'redux/actions';
import * as popups from '../../../constants/popup-types';
import {createAnalyticsItemsList, getMediaPath} from "../../../app/functions";

const FavoriteButton = (props) => {
    const {data = {}, state} = props;

    const dispatch = useDispatch();

    const user = useSelector(store => store.config.UserData);

    if (!user) {
        return null;
    }
    const handleClick = (e) => {
        e.preventDefault();

        if (user) {
            let payload = {benefitId: data.id ?? data.main.id};

            if (state) {
                AnalyticsManager.logRemoveFromFavorites(createAnalyticsItemsList([data]));
                dispatch(Actions.removeFavorite(payload));
            } else {
                AnalyticsManager.logAddToWishlist(createAnalyticsItemsList([{...data, quantity: 1}]))
                dispatch(Actions.addFavorite(payload));
            }
        } else {
            dispatch(Actions.addPopup({type: popups.LOGIN}));
        }
    };

    return (
        <button className="favorite-wrapper" onClick={handleClick}>
            <img src={getMediaPath(state ? on : off)} alt=""/>
        </button>
    )
};

export default FavoriteButton;
